module.exports = __webpack_public_path__ + "img/cards2_front4.96b766cc.png";